var _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDrag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 6,
  r: 2
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 12,
  r: 2
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 18,
  r: 2
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 6,
  r: 2
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 12,
  r: 2
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 18,
  r: 2
})));
export { SvgDrag as ReactComponent };